<template>
    <div class="card-header border-0 py-5">
            <h3 class="card-title align-items-start flex-column">
                <span class="card-label font-weight-bolder text-dark">{{title}}</span>
                <span class="mt-3 text-muted font-weight-bolder font-size-sm">{{subtitle}}</span>
            </h3>
    </div>
    <el-progress type="dashboard" :percentage="percentage" class="my-6">
            <template #default="{ percentage }">
                <span class="percentage-value">{{ percentage }} <i class="el-icon-user icon-2x"></i></span>
                <span class="percentage-label text-muted">{{subtitle}}</span>
            </template>
    </el-progress>
</template>
<script>
export default {
    props:["title", "subtitle", "percentage"]
}
</script>